import React, { createContext, useContext } from 'react';
import { NotificationContextValue } from './types';
import { useNotificationSocket } from './useNotificationSocket';

const NotificationContext = createContext<NotificationContextValue | null>(null);

/**
 * Provides a single shared WebSocket connection for notifications.
 * Wrap this around the authenticated app shell so every page/component
 * that needs notification data shares the same connection.
 */
export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const socket = useNotificationSocket();

  return (
    <NotificationContext.Provider value={socket}>
      {children}
    </NotificationContext.Provider>
  );
};

/**
 * Consume the shared notification state/actions from any component
 * inside the NotificationProvider tree.
 */
export const useNotifications = (): NotificationContextValue => {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error(
      'useNotifications must be used within a <NotificationProvider>. ' +
      'Wrap your app shell with <NotificationProvider>.',
    );
  }

  return context;
};
